import BackdropModal from 'Shared/components/BackdropModal/BackdropModal'
import ServerWaitButton from 'Shared/components/ServerWaitButtonStandalone'

const YesNoModal = ({ show, onAccept, onDecline, title, body, useServerWaitButtons = false }) => {
  return (
    <BackdropModal title={title} open={show} onCancel={onDecline}>
      <div>
        {body && (
          <div>
            <p className="text-center">{body}</p>
          </div>
        )}
        <div>
          {useServerWaitButtons ? (
            <>
              <ServerWaitButton className="button primary margin-right" onClick={onAccept}>
                { i18n.t('shared.messages.yes') }
              </ServerWaitButton>
              <ServerWaitButton className="button secondary" onClick={onDecline}>
                { i18n.t('shared.messages.no') }
              </ServerWaitButton>
            </>
          ) : (
            <>
              <button className="button primary margin-right" onClick={onAccept}>
                { i18n.t('shared.messages.yes') }
              </button>
              <button className="button secondary" onClick={onDecline}>
                { i18n.t('shared.messages.no') }
              </button>
            </>
          )}
        </div>
      </div>
    </BackdropModal>
  )
}

export default YesNoModal
